import { Brand } from '@/domainLogic/index.ts';
import { css } from 'styled-components';

export const cssColorFilters = {
  // FROM BLACK
  blackToGray200:
    'brightness(0) saturate(100%) invert(76%) sepia(5%) saturate(224%) hue-rotate(206deg) brightness(96%) contrast(96%)',
  blackToGray400:
    'brightness(0) saturate(100%) invert(49%) sepia(2%) saturate(1372%) hue-rotate(198deg) brightness(93%) contrast(92%)',
  blackToSuccess600:
    'brightness(0) saturate(100%) invert(40%) sepia(83%) saturate(1624%) hue-rotate(79deg) brightness(99%) contrast(102%)',
  blackToRed:
    'brightness(0) saturate(100%) invert(31%) sepia(98%) saturate(2091%) hue-rotate(360deg) brightness(100%) contrast(108%)',

  // FROM GRAY #3C3C3C
  filterFromGrayToBlue: 'invert(21%) sepia(97%) saturate(1855%) hue-rotate(193deg) brightness(101%) contrast(104%)',
  filterFromGrayToIcebergBlue:
    'saturate(100%) invert(80%) sepia(34%) saturate(7192%) hue-rotate(136deg) brightness(98%) contrast(105%)',
  filterFromGrayToPurple: 'invert(24%) sepia(16%) saturate(1898%) hue-rotate(259deg) brightness(95%) contrast(91%)',
  filterFromGrayToBookinglue:
    'invert(17%) sepia(92%) saturate(1367%) hue-rotate(196deg) brightness(93%) contrast(114%)',
  filterFromGrayToPink: 'invert(12%) sepia(90%) saturate(7470%) hue-rotate(321deg) brightness(93%) contrast(107%)',
  filterFromGrayToGreen: 'invert(18%) sepia(67%) saturate(6586%) hue-rotate(150deg) brightness(103%) contrast(73%)',
  filterFromGrayToOrange: 'invert(57%) sepia(52%) saturate(1169%) hue-rotate(359deg) brightness(100%) contrast(106%)',
};

export const getBrandColorUsingCssFilter = (brand?: Brand) => {
  if (brand === Brand.MILLEMIGLIA) {
    return css`
      filter: ${cssColorFilters.filterFromGrayToGreen};
    `;
  }
  if (brand === Brand.HOLIDAYPIRATES) {
    return css`
      filter: ${cssColorFilters.filterFromGrayToPurple};
    `;
  }
  if (brand === Brand.HOLIDAYGURU) {
    return css`
      filter: ${cssColorFilters.filterFromGrayToIcebergBlue};
    `;
  }
  if (brand === Brand.BOOKING) {
    return css`
      filter: ${cssColorFilters.filterFromGrayToBookinglue};
    `;
  }
  if (brand === Brand.WEGDE) {
    return css`
      filter: ${cssColorFilters.filterFromGrayToOrange};
    `;
  }
  return css`
    filter: ${cssColorFilters.filterFromGrayToPink};
  `;
};

export const getBrandColorUsingCssFilterOnImg = (brand?: Brand) => css`
  img {
    ${getBrandColorUsingCssFilter(brand)};
  }
`;
